import HTTPClient from './http-client';

const END_POINT = '/wateravailability';

const options = {
  cache: {
    maxAge: 5 * 60 * 1000,
    exclude: { query: false }
  }
}

const loadWaterAvailability = async (location_id) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.get(
    `${END_POINT}?location_ids=${location_id}`,
    options
  );
}

export {
  loadWaterAvailability
}
